import {
  type Falsy,
  RPCDocs,
  RPCs,
  useRPC,
  useRPCServerEventHandler,
} from '@therms/react-modules'

type Args = RPCDocs.Events.GetCurrentEventCounts.v1.Args | Falsy

export function useCurrentEventCounts(args?: Args) {
  const {call, data, isCalling} = useRPC<
    Args,
    RPCDocs.Events.GetCurrentEventCounts.v1.Data
  >(RPCs.Events.GetCurrentEventCounts.v1, args, {
    fire: !!args,
  })

  useRPCServerEventHandler('EventCreated', call)
  useRPCServerEventHandler('EventDeleted', call)
  useRPCServerEventHandler('EventDetailsUpdated', call)
  useRPCServerEventHandler('EventStateUpdated', call)

  return {
    counts: data?.counts ?? {active: 0, pending: 0},
    loading: isCalling,
    refresh: call,
  }
}
